import { Controller } from "@hotwired/stimulus"

// Generic visibility controller for showing/hiding named elements
// Usage:
//   <div data-controller="visibility">
//     <button data-action="visibility#show" data-visibility-name-param="backup">Show backup</button>
//     <div data-visibility-name="totp">TOTP input</div>
//     <div data-visibility-name="backup" class="hidden">Backup input</div>
//   </div>
export default class extends Controller {
  // Public actions (callable from data-action)
  show(event) {
    event.preventDefault()
    const name = event.params.name
    this._showByName(name)
  }

  hide(event) {
    event.preventDefault()
    const name = event.params.name
    this._hideByName(name)
  }

  toggle(event) {
    event.preventDefault()
    const name = event.params.name
    const elements = this._findByName(name)
    elements.forEach((el) => el.classList.toggle("hidden"))
  }

  // Private methods
  _showByName(name) {
    const allNamedElements = this.element.querySelectorAll(
      "[data-visibility-name]",
    )
    allNamedElements.forEach((el) => {
      if (el.dataset.visibilityName === name) {
        el.classList.remove("hidden")
        this._enableInputs(el)
      } else {
        el.classList.add("hidden")
        this._disableInputs(el)
      }
    })
    this._autofocus(name)
  }

  _hideByName(name) {
    this._findByName(name).forEach((el) => {
      el.classList.add("hidden")
      this._disableInputs(el)
    })
  }

  _findByName(name) {
    return this.element.querySelectorAll(`[data-visibility-name="${name}"]`)
  }

  _autofocus(name) {
    const container = this.element.querySelector(
      `[data-visibility-name="${name}"]`,
    )
    if (!container) return

    const input = container.querySelector(
      "input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled])",
    )
    if (input) input.focus()
  }

  _disableInputs(container) {
    const inputs = container.querySelectorAll(
      "input:not([type=hidden]), textarea, select",
    )
    inputs.forEach((input) => (input.disabled = true))
  }

  _enableInputs(container) {
    const inputs = container.querySelectorAll(
      "input:not([type=hidden]), textarea, select",
    )
    inputs.forEach((input) => (input.disabled = false))
  }
}
